import { render, staticRenderFns } from "./ObjectAbout.vue?vue&type=template&id=4f38c76a&"
import script from "./ObjectAbout.vue?vue&type=script&lang=js&"
export * from "./ObjectAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports